import axios from 'axios'

const TILES_ENDPOINT = 'https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/tiles'
const GLOBAL_TILES_ENDPOINT = 'https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/global-tiles'

const Tiles = {
  /*
  ** clientId -> required to get clients Tiles.
  */
  getTiles: async (clientId) => {
    if (!clientId) {
      throw new Error('[TILES]: Missing client id')
    }

    try {
      const [tilesResponse, globalTilesResponse] = await Promise.all([
        axios.get(`${TILES_ENDPOINT}/${clientId}`),
        axios.get(`${GLOBAL_TILES_ENDPOINT}/${clientId}`)
      ])

      if (!tilesResponse.data) {
        return 'No tiles found'
      }

      let tiles = [...tilesResponse.data, ...globalTilesResponse.data]
      tiles.sort((a, b) => {
        if (!a.order) {
          a.order = 99
        }
        if (!b.order) {
          b.order = 99
        }
        return (a.order > b.order) ? 1 : -1
      })
      
      for (let i = 0; i < tiles.length; i++) {
        if (tiles[i].children && tiles[i].children.length) {
          tiles[i].children.sort((a, b) => {
            if (!a.order) {
              a.order = 99
            }
            if (!b.order) {
              b.order = 99
            }
            return (a.order > b.order) ? 1 : -1
          })
        }
      }

      return tiles
    } catch (err) {
      throw err
    }
  },
  /*
  ** Tiles -> tiles from getTiles()
  ** skipCustom -> Do not include custom tiles in Routes
  ** skipChildren -> Do not include children in Routes
  */
  getRoutesFromTiles: (tiles, skipCustom, skipChildren) => {
    if (!tiles || !tiles.length) {
      throw new Error('[ROUTES]: Missing tiles')
    }

    let routes = []

    for (let i in tiles) {

      if (skipCustom) {
        if (tiles[i].custom) {
          let tilesWithLinks = tiles.filter(t => t.tileLinks && t.tileLinks.length)
          for (let x = 0; x < tilesWithLinks.length; x++) {
            tilesWithLinks[x].tileLinks.forEach(link => {
              link.iconAccessUrl = tiles[i].iconAccessUrl
            })
          }
          continue
        }
      }


      let tile = tiles[i]
      let tileRoute = {
        path: tile.path,
        name: tile.title.replace(/[^A-Z0-9]+/ig, '').toLowerCase(),
        meta: {
          title: tile.title,
          inverseNav: true,
          icon: tile.iconAccessUrl,
          nav: true,
          order: tile.order,
          filename: 'Tile.vue',
          sso: tile.sso || null,
          ssoEndpoint: tile.ssoEndpoint || null,
          custom: (tile.custom) ? true : false
        }
      }

      if (!skipChildren) {
        tileRoute.children = (!tile.children) ? null : tile.children.map(child => {
          return {
            path: child.path,
            name: tile.title.replace(/[^A-Z0-9]+/ig, '').toLowerCase() +
                  child.title.replace(/[^A-Z0-9]+/ig, '').charAt(0).toUpperCase() +
                  child.title.replace(/[^A-Z0-9]+/ig, '').toLowerCase().slice(1),
            meta: {
              title: child.title,
              inverseNav: true,
              icon: child.iconAccessUrl,
              nav: true,
              order: child.order,
              filename: 'Tile.vue',
              sso: child.sso || null,
              ssoEndpoint: child.ssoEndpoint || null
            }
          }
        })
      }

      routes.push(tileRoute)      
    }

    return(routes)
  },
  /*
  ** dynamicRoutes -> Routes from Tiles / getRoutesFromTiles()
  ** staticRoutes -> Other routes to include e.g. from this.$router.options.routes
  */
  getSearchOptions: (dynamicRoutes, staticRoutes) => {
    let searchOptions = []

    for (let i = 0; i < dynamicRoutes.length; i++) {
      if (!dynamicRoutes[i].children) continue
      searchOptions.push(...dynamicRoutes[i].children.map(route => ({label: route.meta.title, code: route.path})))
    }

    let routerRoutes = staticRoutes.filter(route => route.meta && route.meta.search).map(search => ({
      code: search.path,
      label: search.meta.title
    }))

    searchOptions.push(...routerRoutes)

    return searchOptions
  }
}

export default Tiles